import { Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './components/Home';
import PrivateRoute from './components/PrivateRoute';
import Login from './components/login/Login';
import { Layout } from './layouts/Layout';
import { Path as RoutePath } from "./path";
import { ApplicationState } from './store';
import { connect } from 'react-redux';
import { CircularProgress, ThemeProvider } from '@mui/material';
import theme from './themes/globalStyles';
import EndScreen from './components/endScreen/EndScreen';
import TestForm from './components/testForm/TestForm';


export type AppProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;

function App(props: AppProps) {
    return (
        (props.initAppLoading)
        ? <div style={{ 
            top: "0px",
            left: '0px',
            position: "fixed",
            zIndex: 1500,
            width: '100%',
            height: '100%',
            padding: '50vh 50% 50% 50%',
            background: '#00000030'
        }}>
            <CircularProgress />
        </div>
        : 
        <ThemeProvider theme={theme}>
        <Routes>
            <Route path={RoutePath.login} element={<Login />} />
            <Route path='/' element={<PrivateRoute returnElement={<Layout />}></PrivateRoute>}>
                <Route index element={<Home />} />
                <Route path={RoutePath.home} element={<Home />} />
                <Route path={RoutePath.end} element={<EndScreen />} />
                <Route path={RoutePath.test} element={<TestForm />} />
            </Route>
        </Routes>
        </ThemeProvider> 
    );
}

const mapStateToProps = (state: ApplicationState) => ({
    initAppLoading: state.app.initAppLoading,
})
  
const mapDispatchToProps = {};
  
export default connect(mapStateToProps, mapDispatchToProps)(App as any);
// export default App;